module.exports = __webpack_public_path__ + "static/media/main-img1.87a15a99.jpg";